import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import BuiltInConfigure from './configure-forms/BuiltInConfigure';
import ExternalApiPredefined from './configure-forms/ExternalApiPredefined';
import ExternalApiGeneric from './configure-forms/ExternalApiGeneric';
import CustomScript from './configure-forms/CustomScript';

const Configure = ({ entityId, formData, setFormData }) => {
  const providerType = formData?.rule_type?.trim();

  const handleConfigChange = (newConfig) => {
    setFormData((prev) => ({
      ...prev,
      configuration: {
        ...prev.configuration,
        ...newConfig,
        case_sensitive: false,
        apply_to_nulls: false,
      },
    }));
  };

  const handleRuleTypeIdChange = (ruleTypeId) => {
    setFormData((prev) => ({
      ...prev,
      rule_type_id: ruleTypeId,
    }));
  };

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {!providerType ? (
        <Paper
          elevation={0}
          sx={{
            p: 3,
            borderRadius: 2,
            backgroundColor: '#f9f9f9',
            border: '1px dashed #ccc',
            textAlign: 'center',
          }}
        >
          <Typography variant="subtitle1" sx={{ color: '#555', fontWeight: 500 }}>
            ⚠️ Please select a <strong>Rule Type</strong> from the previous step.
          </Typography>
        </Paper>
      ) : (
        <>
          {providerType === 'built-in' && (
            <BuiltInConfigure
              entityId={entityId}
              formData={formData}
              setFormData={setFormData}
              onConfigChange={handleConfigChange}
              onRuleTypeIdChange={handleRuleTypeIdChange}
            />
          )}
          {providerType === 'external-api-predefined' && (
            <ExternalApiPredefined
              formData={formData}
              setFormData={setFormData}
              onConfigChange={handleConfigChange}
              onRuleTypeIdChange={handleRuleTypeIdChange}
            />
          )}
          {providerType === 'external-api-generic' && (
            <ExternalApiGeneric
              formData={formData}
              setFormData={setFormData}
              onConfigChange={handleConfigChange}
              onRuleTypeIdChange={handleRuleTypeIdChange}
            />
          )}
          {providerType === 'custom-script' && (
            <CustomScript
              formData={formData}
              setFormData={setFormData}
              onConfigChange={handleConfigChange}
              onRuleTypeIdChange={handleRuleTypeIdChange}
            />
          )}
        </>
      )}
    </Box>
  );
};

export default Configure;
